import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import insuranceCard from './modules/insuranceCard';
import navigation from './modules/navigation';
import preAdmission from './modules/preAdmission';
import notification from './modules/notification';

Vue.use(Vuex);

/**
 * Persist auth credentials in session storage
 */
const vuexPersistSession = new VuexPersistence({
  strictMode: true,
  storage: sessionStorage,
  reducer: (state) => ({
    auth: state.auth
  })
});

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {},
  mutations: {
    RESTORE_MUTATION: vuexPersistSession.RESTORE_MUTATION
  },
  actions: {},
  modules: {
    insuranceCard,
    navigation,
    preAdmission,
    notification
  },
  plugins: [vuexPersistSession.plugin]
});

export default store;
